module.exports = "https://static.wmbcdn.com/uniweb/images/b87579ab832c59f5cd6d526075216bc1.svg";